import { Link } from 'react-router-dom';
import { Button } from '@adop/ui';

const CONTENT: Record<string, { title: string; body: string[] }> = {
  pricing: {
    title: 'Pricing',
    body: [
      'adop is free to start: a ready-made website, to-go ordering, reservations and kitchen printing.',
      'You only pay your normal card processing fees when you accept online card payments through Stripe. Pay-in-store orders cost nothing extra.',
    ],
  },
  terms: {
    title: 'Terms of Service',
    body: [
      'By using adop you agree to use it lawfully and to keep your restaurant information accurate.',
      'Card payments are processed by Stripe on your connected account. You are responsible for your own menu pricing, taxes and food safety.',
    ],
  },
  privacy: {
    title: 'Privacy Policy',
    body: [
      'We store the minimum customer information needed to fulfil orders and reservations, and delete it on a rolling retention schedule.',
      'We never sell your data. Restaurant staff only see the orders and reservations for the locations they belong to.',
    ],
  },
};

export function LegalPage({ kind }: { kind: keyof typeof CONTENT }) {
  const content = CONTENT[kind] ?? CONTENT.pricing!;
  return (
    <div className="mx-auto max-w-2xl px-4 py-16">
      <Link to="/" className="text-sm text-zinc-500 hover:text-zinc-900">
        ← Back to adop
      </Link>
      <h1 className="mt-4 text-3xl font-bold tracking-tight text-zinc-900">{content.title}</h1>
      <div className="mt-6 space-y-4 text-zinc-600">
        {content.body.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
      <div className="mt-8">
        <Button onClick={() => (window.location.href = '/')}>Back to marketplace</Button>
      </div>
    </div>
  );
}
